module.exports = __webpack_public_path__ + "img/Tewner.ee8a01d2.png";